// Optional: frontend interactivity for hhm-features-grid block
